// tslint:disable
export const hasArray = (values: any): any[] | undefined => {
    return (typeof values !== 'string') && values && values.length ? values : undefined;
};